import { Injectable } from '@angular/core';
import { type Data, Router } from '@angular/router';
import { type WithRef } from '@principle-theorem/shared';
import { type IStaffer } from '@principle-theorem/principle-core/interfaces';
import { BaseCurrentFirestoreModel } from './base-current-firestore-model';

@Injectable({
  providedIn: 'root',
  useFactory: (route: Router) => new CurrentStafferScope(route),
  deps: [Router],
})
export class CurrentStafferScope extends BaseCurrentFirestoreModel<
  WithRef<IStaffer>
> {
  protected _propertyAccessor(data: Data): WithRef<IStaffer> | undefined {
    if (data.staffer) {
      return data.staffer as WithRef<IStaffer>;
    }
  }
}
